/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '330300': {
    position: {
      left: '818px',
      top: '650px'
    },
    collectPosition: {
      left: '135px',
      top: '95px'
    },
    background: require('../../mapPoint/mapPicture/zhejiang/wenzhou.png')
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/cityPoint/zhejiang.js
// module id = null
// module chunks = 